import { takeEvery, put, select } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import {
  FEATURE_UPDATE_COMPLETE_BY_VEHICLE_AREA,
  getTruckDetails,
} from 'actions/truck'
import { fetchSwitchLinkedFeatures } from 'actions/dash'
import { clearFilterTerms, clearAllDropdowns } from 'actions/search'
import { getPathname } from 'selectors/router'
import { getSelectedId } from 'selectors/navigator'
import { setComponentMeta, setSelectedIdWithDrawer } from 'actions/navigator'
import {
  CEEAVehicleTabs,
  NOTIFICATION_SUCCESS,
  FEATURE,
  SharedVehicleTabs,
  LIST,
  DASH_VIEW,
  NOTIFICATION_INFO,
} from 'utils/constants'
import strings from 'utils/strings'
import { createSystemNotification } from 'actions/application'
import {
  ADD_FEATURE_SUCCESS_SNG,
  ADD_FEATURE_SUCCESS_ECU,
  ADD_FEATURE_SUCCESS,
  OPTIONAL_SOLENOIDS_EXCEEDED,
} from 'utils/notifications'
import { setIsDrawerVisible } from 'actions/drawer'

export default function* watchFeatureUpdateForVehicleArea() {
  yield takeEvery(
    FEATURE_UPDATE_COMPLETE_BY_VEHICLE_AREA,
    vehicleAreaFeatureUpdate
  )
}

function* vehicleAreaFeatureUpdate({ vehicleArea, serialNumber, options }) {
  const selectedId = yield select(getSelectedId)
  const { switchandgauge, ecus } = CEEAVehicleTabs
  const { summary } = SharedVehicleTabs
  const isChecPlusSwitchAndGauge = vehicleArea === switchandgauge
  const isChecPlusECU = vehicleArea === ecus
  if (isChecPlusSwitchAndGauge) {
    if (selectedId) {
      yield put(
        fetchSwitchLinkedFeatures({ switchId: selectedId, serialNumber })
      )
    }
    yield put(
      createSystemNotification({
        notificationMessage: strings.feature_updated_swga,
        persistent: true,
        closable: true,
        notificationType: NOTIFICATION_SUCCESS,
        notificationId: ADD_FEATURE_SUCCESS_SNG,
      })
    )
  }
  if (isChecPlusECU) {
    const currentPath = yield select(getPathname)
    // Refresh truck details to update ECP/Pneumatics data with new solenoids
    yield put(getTruckDetails({ serialNumber }))

    yield put(
      createSystemNotification({
        notificationMessage: strings.feature_updated_ecu,
        persistent: true,
        closable: true,
        notificationType: NOTIFICATION_SUCCESS,
        notificationId: ADD_FEATURE_SUCCESS_ECU,
      })
    )
    yield put(push(currentPath))
  }
  if (vehicleArea === summary) {
    // Refresh truck details to update ECP/Pneumatics data with new solenoids
    yield put(getTruckDetails({ serialNumber }))

    yield put(
      createSystemNotification({
        notificationMessage: strings.vehicle_updated,
        persistent: true,
        closable: true,
        notificationType: NOTIFICATION_SUCCESS,
        notificationId: ADD_FEATURE_SUCCESS,
      })
    )
    if (options?.optionalSolenoidsExceedingLimit?.length) {
      yield put(
        createSystemNotification({
          notificationMessage: strings.optional_solenoids_exceeding_limits,
          persistent: true,
          notificationType: NOTIFICATION_INFO,
          notificationId: OPTIONAL_SOLENOIDS_EXCEEDED,
          actionTrigger: {
            onClick: () => options?.goToPneumatics(serialNumber),
            text: strings.manually_update_solenoids,
            onColor: 'dark',
          },
        })
      )
    }
  }
  yield put(clearFilterTerms(FEATURE))
  yield put(clearAllDropdowns(FEATURE))
  yield put(setSelectedIdWithDrawer(null))
  if (window?.location?.pathname?.includes(SharedVehicleTabs.switchandgauge)) {
    yield put(
      setComponentMeta(DASH_VIEW, {
        view: LIST,
        id: '',
      })
    )
    yield put(setSelectedIdWithDrawer(DASH_VIEW))
    yield put(setIsDrawerVisible(false))
  }
}
